export default __webpack_public_path__ + "static/media/section1_screens.4faaf576.png";